import Alerts from "../web/components/Alerts/Alerts";

export const attachEvento = (data, setForm) => {
  let categorias = [];
  data.categorias.map((c) => {
    categorias.push(c.id);
  });

  let sala = {
    id: ["", "required"],
    evento_id: [data.id, "required"],
    nombre: [data.nombre_sitio, "required"],
    razon_social: ["", ""],
    email: [data.email_sitio, "required"],
    telefono: [data.telefono_sitio, "required"],
    direccion: [data.direccion, "required"],
    localidad: [data.localidad, "required"],
    provincia: [data.provincia, "required"],
  };

  let ficha_tecnica = [];

  if (data.ficha_tecnica) {
    if (typeof data.ficha_tecnica == "string") {
      Object.keys(JSON.parse(data.ficha_tecnica)).map((f) => {
        let ficha = {
          rol: f,
          nombre: JSON.parse(data.ficha_tecnica)[f],
        };

        ficha_tecnica.push(ficha);
      });
    } else {
      Object.keys(data.ficha_tecnica).map((f) => {
        let ficha = {
          rol: f,
          nombre: data.ficha_tecnica[f],
        };

        ficha_tecnica.push(ficha);
      });
    }
  }

  let links = [];

  if (data.link) {
    if (typeof data.ficha_tecnica == "string") {
      Object.keys(JSON.parse(data.link)).map((f) => {
        let ficha = {
          nombre: f,
          url: JSON.parse(data.link)[f],
        };

        links.push(ficha);
      });
    } else {
      Object.keys(data.link).map((f) => {
        let ficha = {
          nombre: f,
          url: data.link[f],
        };

        links.push(ficha);
      });
    }
  }

  let entradas = [];

  data.entradas.map((e) => {
    let entrada = {
      id: [e.id, "required"],
      evento_id: [data.id, "required"],
      sector: [e.sector, ""],
      nombre: [e.nombre, "required"],
      gratis: [e.tipo, ""],
      tipo: [e.tipo, "required"],
      precio: [e.precio, "required"],
      habilitacion_hora: [e.habilitacion_hora, "required"],
      habilitacion_fecha: [e.habilitacion_fecha, "required"],
      vencimiento_fecha: [e.vencimiento_fecha, ""],
      stock: [e.stock ? e.stock : 0, "required"],
      multiplicador: [e.multiplicador ? e.multiplicador : "", ""],
      status_id: [e.status == "ACTIVO" ? 1 : 0, "required"],
      created_at: [e.created_at, "required"],
      update_at: [e.updated_at, "required"],
    };

    entradas.push(entrada);
  });

  let liquidaciones = [];

  data.liquidacion.map((l) => {
    let liquidacion = {
      id: [l.id, "required"],
      evento_id: [data.id, "required"],
      porcentaje: [l.porcentaje, "required"],
      created_at: [l.created_At, "required"],
      updated_at: [l.updated_at, "required"],
      entidad: [l.entidad, "required"],
      cbu: [l.cbu, "required"],
      email: [l.email, ""],
      identificador: [null, "required"],

      comprobante_cbu: ["", "required"],
      comprobante_afip: ["", "required"],
      comprobante_entidad: ["", "required"],
      comprobante_cbu_url: [l.comprobante_cbu, "required"],
      comprobante_afip_url: [l.comprobante_afip, "required"],
      comprobante_entidad_url: [l.comprobante_entidad, "required"],

      dato_fiscal: [l.dato_fiscal, "required"],
      porcentaje_argentores: [null, "required"],
    };

    liquidaciones.push(liquidacion);
  });
  let nombreGrupo = data.nombre_grupo == 'null' || !data.nombre_grupo ? null : data.nombre_grupo;
  let result = {
    id: [data.id, "required"],
    usuarios_id: [data.usuarios_id, "required"],
    status_id: [data.status, "required"],
    imagen: ["", "required"],
    imagen_url: [
      "https://antesala.com.ar/assets/img/eventos/" + data.imagen,
      "",
    ],
    //url_youtube: ["", ""],
    nombre: [data.nombre, "required"],
    nombre_grupo: [nombreGrupo, "required"],
    duracion: [data.duracion, "required"],

    clase: [data.clase, "required"],
    grupo: [data.grupo, ""],
    atp: [data.atp, ""],
    adultos: [data.adultos, ""],
    infancias: [data.infancias, ""],

    descripcion: [data.descripcion, "required"],

    nombre_sitio: ["", ""],
    maps_sitio: ["", ""],
    direccion: ["", ""],
    provincia: ["", ""],
    localidad: ["", ""],
    email_sitio: ["", ""],
    telefono_sitio: ["", ""],
    website_sitio: ["", ""],
    historia: ["", ""],
    visitas: [data.visitas, ""],

    categorias: [categorias, "required"],
    created_at: [data.created_at, "required"],
    updated_at: [data.updated_at, "required"],

    fechas: [data.fechasJSON, "required"],

    permisos: [data.permisos, ""],

    ["fecha-day"]: [
      [
        "domingo",
        "lunes",
        "martes",
        "miércoles",
        "jueves",
        "viernes",
        "sábado",
      ],
      "",
    ],
    ["fecha-hora"]: ["", "required"],
    ["fecha-stock"]: ["", "required"],

    link: [links, ""],
    ["link-nombre"]: ["", "required"],
    ["link-url"]: ["", "required"],

    ficha_tecnica: [ficha_tecnica, "required"],
    ["ficha_tecnica-nombre"]: ["", "required"],
    ["ficha_tecnica-rol"]: ["", "required"],

    ["sala-search"]: ["", ""],
    sala: [sala, "required"],

    entradas: [entradas, "required"],
    ["entrada-id"]: [null, ""],
    ["entrada-sector"]: ["", ""],
    ["entrada-status"]: [1, ""],
    ["entrada-gratis"]: ["", ""],
    ["entrada-tipo"]: ["", "required"],
    ["entrada-precio"]: [0, ""],
    ["entrada-cierre"]: ["00:00", ""],
    ["entrada-multiplicador"]: [null, ""],
    ["entrada-habilitacion"]: ["", "required"],
    ["entrada-vencimiento"]: ["", ""],
    ["entrada-stock"]: [0, ""],

    liquidacion: [liquidaciones, "required"],
    ["liquidacion-id"]: [null, ""],
    ["liquidacion-cuit"]: ["", "required"],
    ["liquidacion-fiscal"]: ["", "required"],
    ["liquidacion-comprobante_afip"]: ["", "required"],
    ["liquidacion-comprobante_cuit"]: ["", "required"],
    ["liquidacion-comprobante_cbu"]: ["", "required"],
    ["liquidacion-comprobante_afip_url"]: ["", "required"],
    ["liquidacion-comprobante_cuit_url"]: ["", "required"],
    ["liquidacion-comprobante_cbu_url"]: ["", "required"],
    ["liquidacion-cbu"]: ["", "required"],
    ["liquidacion-email"]: ["", "required"],
    ["liquidacion-porcentaje"]: [0, "required"],

    // Mapa de Teatro - Parsear desde JSON del backend
    site_maps: [data.site_maps ? (typeof data.site_maps === "string" ? JSON.parse(data.site_maps) : data.site_maps) : { version: "1.0", sectores: [] }, ""],

    usuario: [null, ""],
    reportes: [data.reportes, ""]
  };

  return setForm(result);
};

export const dateRange = (fecha, setForm, form) => {
  //e.preventDefault();

  /*
  if (
    fecha[0].endDate == null ||
    form.time.trim() == "" ||
    form.stock.trim() == ""
  ) {
    setAlert({
      ...alert,
      fecha: true,
    });
    return AlertWarning(
      "Complete todos los campos antes de cargar una fecha",
      "Advertencia"
    );
  }
  */

  const dias_semana = [
    "domingo",
    "lunes",
    "martes",
    "miércoles",
    "jueves",
    "viernes",
    "sábado",
  ];

  const meses = [
    "enero",
    "febrero",
    "marzo",
    "abril",
    "mayo",
    "junio",
    "julio",
    "agosto",
    "septiembre",
    "octubre",
    "noviembre",
    "diciembre",
  ];


  if(!fecha[0].startDate || !fecha[0].endDate){
    Alerts({
      msg: "Alert",
      title: "Selecciona un rango de fecha en el calendario",
      code: "401",
      type: "warning",
    });
    return null;
  }

  if(
    !form["fecha-hora"][0] || 
    form["fecha-hora"][0] == '' || 
    !form["fecha-stock"][0] || 
    form["fecha-stock"][0] == '' 
  ){
    Alerts({
      msg: "Alert",
      title: "Completa el stock y horario de tus fechas",
      code: "401",
      type: "warning",
    });
    return null;
  }

  let start = fecha[0].startDate.toLocaleDateString();
  let end = fecha[0].endDate.toLocaleDateString();

  let array = [];

  start = start.split("/");
  end = end.split("/");

  for (let s = parseInt(start[1]); s <= parseInt(end[1]); s++) {
    const mes = s;
    let diasTotal;

    if (s !== parseInt(start[1])) {
      for (let i = 1; i <= parseInt(end[0]); i++) {
        let concatDate = mes + "/" + i + "/" + start[2];
        let dia = new Date(concatDate);
        let fechaFormat =
          dias_semana[dia.getDay()] +
          ", " +
          dia.getDate() +
          " de " +
          meses[dia.getMonth()] +
          " de " +
          dia.getUTCFullYear();

        array.push(fechaFormat);
      }
    } else {
      diasTotal =
        start[1] != end[1]
          ? new Date(parseInt(start[2]), s, 0).getDate()
          : end[0];

      for (let i = parseInt(start[0]); i <= diasTotal; i++) {
        let concatDate = start[1] + "/" + i + "/" + start[2];
        let dia = new Date(concatDate);
        let fechaFormat =
          dias_semana[dia.getDay()] +
          ", " +
          dia.getDate() +
          " de " +
          meses[dia.getMonth()] +
          " de " +
          dia.getUTCFullYear();

        array.push(fechaFormat);
      }
    }
  }


  form["fecha-day"][0].map((day) => {
    array = array.filter((date) => {
      const dia = date.split(",")[0].trim();
      return form["fecha-day"][0].includes(dia);
    });
  });


  if (array.length == 0) {
    Alerts({
      msg: "Alert",
      title: "El rango de fecha no contiene un día habil",
      code: "401",
      type: "warning",
    });

    return null;
  }

  let objFechas;
  let fechas = [];

  if (form.fechas[0].length == 0) {
    fechas = form.fechas[0].length > 0 ? form.fechas[0] : [];
  } else {
    fechas = form.fechas[0];
  }

  let repeatDate = false;

  fechas.map((fecha) => {
    array.map((arr) => {
      if (
        arr + " HORA:" + form["fecha-hora"][0] ==
        fecha.fechas[0] + " HORA:" + fecha.hora
      ) {
        repeatDate = true;
      }
    });
  });

  if (repeatDate) {
    Alerts({
      msg: "Alert",
      title: "Fecha u Horario duplicado",
      code: "401",
      type: "warning",
    });

    return null;
  }

  array.map((item) => {
    objFechas = {
      fechas: [item],
      hora: form["fecha-hora"][0],
      stock: form["fecha-stock"][0],
    };

    fechas.push(objFechas);
  });

  return fechas;

  //setForm({
  //  ...form,
  //  fecha: fechas,
  //});
};

export const porcentaje = (liquidaciones, porcentaje) => {
  let result = 100;

  liquidaciones.map((l) => {
    result = result - l.porcentaje[0];
  });

  result = result - porcentaje;

  return result;
};

export const Validate = (form, validation, clave) => {
  let resValidate = { ...validation };

  //Validacion de campos
  if (!clave) {
    Object.keys(form).map((campo) => {
      //
      let input_clave = campo.split("-");

      if (input_clave.length == 1) {
        let validate = false;
        let msg = "";

        //Require validate
        if (
          (!form[campo][0] && form[campo].indexOf("required") > -1) ||
          (form[campo][0] == "" && form[campo].indexOf("required") > -1)
        ) {
          validate = true;
          msg = "El campo " + campo + " es requerido.";
          resValidate = {
            ...resValidate,
            [campo]: {
              status: validate,
              msg: msg,
            },
            error: {
              status: validate,
              msg: msg,
            },
          };
        }

        let min = Array.isArray(form[campo])
          ? ""
          : form[campo].filter((item) => item.search("min") != -1);
        min = min.length > 0 ? min[0].split(":")[1] : 0;

        let max = Array.isArray(form[campo])
          ? ""
          : form[campo].filter((item) => item.search("max") != -1);
        max = max.length > 0 ? max[0].split(":")[1] : 0;

        if (min !== 0 && form[campo][0].length < min) {
          validate = true;
          msg =
            "El campo " + campo + " debe tener mas de " + min + " caracteres.";
          resValidate = {
            ...resValidate,
            [campo]: {
              status: validate,
              msg: msg,
            },
            error: {
              status: validate,
              msg: msg,
            },
          };
        }

        if (max !== 0 && form[campo][0].length > max) {
          validate = true;
          msg = "El campo " + campo + " supera los " + max + " caracteres.";
          resValidate = {
            ...resValidate,
            [campo]: {
              status: validate,
              msg: msg,
            },
            error: {
              status: validate,
              msg: msg,
            },
          };
        }

        //check validation
        if (!validate) {
          resValidate = {
            ...resValidate,
            [campo]: {
              status: validate,
              msg: msg,
            },
          };
        }
      }
    });
  }

  if (clave) {
    Object.keys(form).map((campo) => {
      let input_clave = campo.split("-");

      if (input_clave[0] == clave && input_clave.length > 1) {
        //
        let validate = false;
        let msg = "";

        //Require validate
        if (
          (!form[campo][0] && form[campo].indexOf("required") > -1) && form[campo][0] != 0 ||
          (form[campo][0] == "" && form[campo].indexOf("required") > -1) && form[campo][0] != 0
        ) {
          console.log("campo", form[campo][0])
          validate = true;
          msg = "El campo " + campo + " es requerido.";
          resValidate = {
            ...resValidate,
            [campo]: {
              status: validate,
              msg: msg,
            },
            error: {
              status: validate,
              msg: msg,
            },
          };
        }

        let min = Array.isArray(form[campo])
          ? ""
          : form[campo].filter((item) => item.search("min") != -1);
        min = min.length > 0 ? min[0].split(":")[1] : 0;

        let max = Array.isArray(form[campo])
          ? ""
          : form[campo].filter((item) => item.search("max") != -1);
        max = max.length > 0 ? max[0].split(":")[1] : 0;

        if (min !== 0 && form[campo][0].length < min) {
          validate = true;
          msg =
            "El campo " + campo + " debe tener mas de " + min + " caracteres.";
          resValidate = {
            ...resValidate,
            [campo]: {
              status: validate,
              msg: msg,
            },
            error: {
              status: validate,
              msg: msg,
            },
          };
        }

        if (max !== 0 && form[campo][0].length > max) {
          validate = true;
          msg = "El campo " + campo + " supera los " + max + " caracteres.";
          resValidate = {
            ...resValidate,
            [campo]: {
              status: validate,
              msg: msg,
            },
            error: {
              status: validate,
              msg: msg,
            },
          };
        }

        //check validation
        if (!validate) {
          resValidate = {
            ...resValidate,
            [campo]: {
              status: validate,
              msg: msg,
            },
            error: {
              status: validate,
              msg: msg,
            },
          };
        }
      }
    });
  }

  return resValidate;
};

export const nextDate = (fechas) => {
  // Obtener la fecha actual sin hora
  const hoy = new Date();
  hoy.setHours(0, 0, 0, 0);
  // Filtrar fechas desde hoy en adelante y obtener la más próxima
  const fechaProxima = fechas
    .map((f) => new Date(`${f.fecha} ${f.hora}`)) // Convertir a objeto Date
    .filter((fecha) => fecha >= hoy) // Filtrar solo futuras o de hoy
    .sort((a, b) => a - b)[0]; // Tomar la más cercana



  if (fechaProxima) {
    // Formatear en español
    const formatoFecha = new Intl.DateTimeFormat("es-ES", {
      weekday: "long",
      day: "numeric",
      month: "long",
      year: "numeric",
    });

    return formatoFecha.format(fechaProxima);
  } else {
    return "No hay fechas futuras disponibles.";
  }
};

export const startEndDate = (fechas) => {
  // Extraer y ordenar fechas
  const fechasOrdenadas = fechas
    .map((f) => new Date(f.fecha))
    .sort((a, b) => a - b);

  // Obtener la fecha menor y mayor
  const fechaMin = fechasOrdenadas[0];
  const fechaMax = fechasOrdenadas[fechasOrdenadas.length - 1];

  // Formatear fechas en español con año incluido
  const formatoFecha = new Intl.DateTimeFormat("es-ES", {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
  });

  const fechaMinStr = `Desde el ${formatoFecha.format(fechaMin)}`;
  const fechaMaxStr = ` hasta el ${formatoFecha.format(fechaMax)}`;

  return fechaMinStr + fechaMaxStr;
};

export const upcomingDate = (fecha, hora) => {
  const meses = {
    enero: 0,
    febrero: 1,
    marzo: 2,
    abril: 3,
    mayo: 4,
    junio: 5,
    julio: 6,
    agosto: 7,
    septiembre: 8,
    octubre: 9,
    noviembre: 10,
    diciembre: 11,
  };

  const hoy = new Date();

  const partes = fecha.split(", ")[1]?.split(" ");
  if (!partes || partes.length < 4) return false;

  const [dia, de, mesTexto, re, año] = partes;

  const mes = meses[mesTexto.toLowerCase()]; // Convertir nombre de mes a número

  if (mes === undefined) return false;

  let hour = hora.split(':')

  const fechaEvento = new Date(año, mes, dia, hour[0], hour[1]);

  return fechaEvento > hoy ? true : false;
};

export const sortDescDate = (datos) => {
  const meses = {
    enero: 0,
    febrero: 1,
    marzo: 2,
    abril: 3,
    mayo: 4,
    junio: 5,
    julio: 6,
    agosto: 7,
    septiembre: 8,
    octubre: 9,
    noviembre: 10,
    diciembre: 11,
  };

  function parseFecha(fechaStr, horaStr) {
    const partes = fechaStr.replace(/^.+?,\s*/, "").split(" de ");
    const dia = parseInt(partes[0]);
    const mes = meses[partes[1].toLowerCase()];
    const anio = parseInt(partes[2]);
    const [hora, minutos] = horaStr.split(":").map(Number);

    return new Date(anio, mes, dia, hora, minutos);
  }

  datos.sort((a, b) => {
    const fechaA = parseFecha(a.fechas[0], a.hora);
    const fechaB = parseFecha(b.fechas[0], b.hora);
    return fechaB - fechaA;
  });

  return datos
};

export const parseDateIso = (fechaTexto) => {
  if (!fechaTexto || fechaTexto == undefined) {
    return null;
  }

  console.log(fechaTexto);

  const meses = {
    'enero': '01', 'febrero': '02', 'marzo': '03', 'abril': '04',
    'mayo': '05', 'junio': '06', 'julio': '07', 'agosto': '08',
    'septiembre': '09', 'octubre': '10', 'noviembre': '11', 'diciembre': '12'
  };

  const match = fechaTexto.match(/(\d{1,2}) de (\w+) de (\d{4})/);

  if (match) {
    const dia = match[1].padStart(2, '0');
    const mes = meses[match[2].toLowerCase()];
    const año = match[3];

    return `${año}-${mes}-${dia}`;
  }

  return null;
}

/**
 * Mapea los datos del evento desde el backend al formato del formulario
 */
export const mapEventoToForm = (eventoData, formTemplate) => {
  if (!eventoData) return formTemplate;

  const mappedForm = { ...formTemplate };

  // Campos básicos
  if (eventoData.id) mappedForm.id = [eventoData.id, "required"];
  if (eventoData.nombre) mappedForm.nombre = [eventoData.nombre, "required"];
  if (eventoData.descripcion) mappedForm.descripcion = [eventoData.descripcion, "required"];
  if (eventoData.descripcion_corta) mappedForm.descripcion_corta = [eventoData.descripcion_corta, "required"];
  if (eventoData.imagen) mappedForm.imagen = [eventoData.imagen, "required"];
  if (eventoData.categoria_id) mappedForm.categoria_id = [eventoData.categoria_id, "required"];
  if (eventoData.produccion_id) mappedForm.produccion_id = [eventoData.produccion_id, "required"];
  if (eventoData.comision) mappedForm.comision = [eventoData.comision, "required"];
  if (eventoData.duracion) mappedForm.duracion = [eventoData.duracion, ""];
  if (eventoData.edad) mappedForm.edad = [eventoData.edad, ""];
  if (eventoData.tags) mappedForm.tags = [eventoData.tags, ""];
  if (eventoData.status_id) mappedForm.status_id = [eventoData.status_id, "required"];
  if (eventoData.usuarios_id) mappedForm.usuarios_id = [eventoData.usuarios_id, "required"];

  // Galería
  if (eventoData.galeria && eventoData.galeria.length > 0) {
    mappedForm.galeria = [eventoData.galeria.map(g => g.imagen), ""];
  }

  // Sala
  if (eventoData.sala) {
    mappedForm.sala = [{
      id: [eventoData.sala.id || "", "required"],
      nombre: [eventoData.sala.nombre || eventoData.nombre_sitio || "", "required"],
      razon_social: [eventoData.sala.razon_social || "", ""],
      email: [eventoData.sala.email || eventoData.email_sitio || "", "required"],
      telefono: [eventoData.sala.telefono || eventoData.telefono_sitio || "", "required"],
      direccion: [eventoData.sala.direccion || eventoData.direccion || "", "required"],
      localidad: [eventoData.sala.localidad || eventoData.localidad || "", "required"],
      provincia: [eventoData.sala.provincia || eventoData.provincia || "", "required"],
    }, "required"];
  }

  // Fechas
  if (eventoData.fechas && eventoData.fechas.length > 0) {
    const fechasMapped = eventoData.fechas.map(f => ({
      hora: f.hora || "00:00",
      stock: f.stock || 0,
      fechas: [f.fecha || ""],
    }));
    mappedForm.fechas = [fechasMapped, "required"];
  }

  // Entradas
  if (eventoData.entradas && eventoData.entradas.length > 0) {
    const entradasMapped = eventoData.entradas.map(e => ({
      id: [e.id, "required"],
      evento_id: [e.evento_id, "required"],
      nombre: [e.nombre, "required"],
      sector: [e.sector, ""],
      tipo: [e.tipo, ""],
      gratis: [e.gratis || e.tipo, ""],
      precio: [e.precio, "required"],
      habilitacion_hora: [e.habilitacion_hora, "required"],
      habilitacion_fecha: [e.habilitacion_fecha, "required"],
      vencimiento_fecha: [e.vencimiento_fecha || "", ""],
      stock: [e.stock || null, ""],
      multiplicador: [e.multiplicador || null, "required"],
      status_id: [e.status_id, "required"],
      created_at: [e.created_at, "required"],
      update_at: [e.updated_at, "required"],
    }));
    mappedForm.entradas = [entradasMapped, "required"];
  }

  // Liquidaciones
  if (eventoData.liquidaciones && eventoData.liquidaciones.length > 0) {
    const liquidacionesMapped = eventoData.liquidaciones.map(l => ({
      id: [l.id, "required"],
      evento_id: [l.evento_id, "required"],
      porcentaje: [l.porcentaje, "required"],
      created_at: [l.created_at, "required"],
      updated_at: [l.updated_at, "required"],
      entidad: [l.entidad, "required"],
      cbu: [l.cbu, "required"],
      identificador: [l.identificador, "required"],
      comprobante_cbu: [l.comprobante_cbu, "required"],
      comprobante_afip: [l.comprobante_afip, "required"],
      comprobante_entidad: [l.comprobante_entidad, "required"],
      comprobante_cbu_url: [l.comprobante_cbu_url || l.comprobante_cbu, "required"],
      comprobante_afip_url: [l.comprobante_afip_url || l.comprobante_afip, "required"],
      comprobante_entidad_url: [l.comprobante_entidad_url || l.comprobante_entidad, "required"],
      dato_fiscal: [l.dato_fiscal, "required"],
      email: [l.email, "required"],
      porcentaje_argentores: [l.porcentaje_argentores, "required"],
    }));
    mappedForm.liquidacion = [liquidacionesMapped, "required"];
  }

  // Reportes (si existen)
  if (eventoData.reportes) {
    mappedForm.reportes = [eventoData.reportes, ""];
  }

  return mappedForm;
}
